import { render, staticRenderFns } from "./NlQuery.vue?vue&type=template&id=70c84a50&scoped=true"
import script from "./NlQuery.vue?vue&type=script&lang=js"
export * from "./NlQuery.vue?vue&type=script&lang=js"
import style0 from "./NlQuery.vue?vue&type=style&index=0&id=70c84a50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c84a50",
  null
  
)

export default component.exports